module.exports = __webpack_public_path__ + "static/media/telegram-icon.43d3300d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/telegram-icon.svg
// module id = 1583
// module chunks = 0